import { AllBannersQuery, useFetchAllBanners } from '@@partner:graphql/query/banners/allBanners.gql'
import useFetchMorePagination from '@@partner:helpers/hooks/useFetchMorePagination'
import { usePartner } from '@@partner:helpers/hooks/auth'
import { renderLazyPickerMenu } from '@components/common/pickers'
import React, { useCallback } from 'react'
import {  SelectPicker } from 'rsuite'
import { MainPageBlockForm } from '../form/MainPageConfigFormState'
import EntityLink from './EntityLink'


type BannerBlockProps = {
  block: MainPageBlockForm
  onChange: (block: MainPageBlockForm) => void
}

export default function BannerBlock ({
  block,
  onChange
}: BannerBlockProps) {
  const { brandSlug } = usePartner()
  const [ nameFilter, setNameFilter ] = React.useState<string>('')

  const { data, loading, error, fetchMore } = useFetchAllBanners({
    filter: {
      fields: [ 'name' ],
      op: nameFilter.length > 0 ? 'starts_with' : 'unwrap',
      value: [ nameFilter ]
    },
    pager: { 
      limit: 20
    },
    sort: {
      fieldName: 'created_at',
      direction: 0
    }
  })

  const updaterFunction = useCallback((cached: AllBannersQuery, fetched: AllBannersQuery) => {
    const prev = cached?.allBanners?.edges ?? []
    const curr = fetched?.allBanners?.edges ?? []

    return {
      hasMore: curr.length > 0,
      result: {
        allBanners: {
          ...fetched.allBanners,
          edges: [ ...prev, ...curr ]
        }
      }
    }
  }, [])

  const { hasMore, fetchNextPage } = useFetchMorePagination({
    loading,
    page: data?.allBanners.pageInfo.page ?? 1,
    pageVariable: 'pager',
    usePager: true,
    fetchMore,
    updaterFunction,
  })

  const banners = data?.allBanners.edges.map((banner) => ({
    label: banner.name,
    value: banner.id,
  })) ?? []

  const onItemsRendered = (props: any) => {
    if (props.visibleStopIndex >= banners.length - 1 && hasMore) {
      fetchNextPage()
    }
  }

  return (
    <div>
      <h4>Выберите баннер:</h4>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <SelectPicker
          data={banners}
          value={block.payload?.id}
          loading={loading && !data}
          onSelect={(value) => {
            if (onChange && value) {
              onChange({
                ...block,
                payload: {
                  id: value,
                }
              })
            }
          }}
          onSearch={setNameFilter}
          renderMenu={renderLazyPickerMenu(loading, data)}
          placeholder="Выберите баннер"
          listProps={{
            onItemsRendered
          }}
          style={{ flex: 1 }}
        />
        <EntityLink
          entityId={block.payload?.id}
          entityType="banner"
          brandSlug={brandSlug}
          tooltip="Перейти к баннеру"
        />
      </div>
    </div>
  )
}